import React, { Component } from 'react'
import { connect } from 'react-redux'
import SkgroupForm from './skgroup_form'
import SkgroupsListFilter from './skgroupsListFilter'
import * as actions from '../../actions'
import {List, ListItem} from 'material-ui/List';
import SocialGroup from 'material-ui/svg-icons/social/group';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';

var FileSaver = require('file-saver');

var jsonpatch = require('fast-json-patch')
const uuidv4 = require('uuid/v4');
var params = '?';
var hasEdited = false;
var patchresponsed = true;

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};

var shouldSave = true;
var closeRequest = null

class Skgroups extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
    closeRequest = null
  }

  componentWillMount() {
    this.props.fetchMessage('/groups/self-knowledge', '?offset=0&limit=50');
    // this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : year
    this.props.getEnums('/dev.enum/group-types', '?detailed', 'GroupTypes');
    //this.props.getEnums('/dev.enum/training-status', '', 'TrainingStatus');
  }

  componentDidMount() {
    var that = this
    closeRequest = function() {
      window.onbeforeunload = function() {
        that.setState({iscloserequest: true});
        that.handleFakeSubmit(false)
        if (that.state.openedform) {
          if (!that.state.isemptyonclose) {
            that.setState({iscloserequest: false});
            return 'You have unsaved changes!';
          }

        }
      }
    }
    closeRequest()
    let actualHref = window.location.href;
    if ( actualHref.substring(actualHref.length - 7).indexOf('groups') === -1 ) {
      let groupId = actualHref.substring((actualHref.indexOf('groups') + 7))
      window.history.pushState({"html":document.documentElement.innerHTML,"pageTitle":document.title},"", actualHref.substring( 0, (actualHref.indexOf('groups') + 7) ));
      this.props.openGroup('/groups', '/'+groupId);
      this.setState({open: true});
      this.setState({openedform: true});
    }
  }

  state = {
    open: false,
    openedform: false,
    iscloserequest: false,
    isemptyonclose: false,
    filterparams: "?",
  }

  openReferedGroup = () => {
  }

  handleOpen = ( val ) => {
    this.props.openGroup('/groups', '/'+val);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleNewOpen = ( val ) => {
    this.props.openGroup('/groups', '/'+val, false);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleClose = () => {
    this.handleFakeSubmit(false);
    //if (hasEdited) {
    //  if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.')) {
    //    this.props.closeGroup()
    //    this.props.fetchMessage('/groups/self-knowledge', params);
    //    this.setState({open: false});
    //  }
    //} else {
    //  this.props.closeGroup()
    //  this.props.fetchMessage('/groups/self-knowledge', params);
    //  this.setState({open: false});
    //}
    //this.props.closeGroup()
    //this.props.fetchMessage('/groups/self-knowledge', params);
    //this.setState({open: false});
  }

  handleSubmit({id, positionNumber, type, leaders, groupSupervisor, startDate, endDate, lessonCount, location, participantCount, registrationFee, recordDelivered, comments, commentsnew, participants, groupRegistrationFee}) {
    if (shouldSave && typeof positionNumber === 'undefined' || shouldSave && positionNumber === null || shouldSave && positionNumber.trim() === "") {
      alert('Pozíciószám megadása kötelező');
      return void(0)
    }
    let patchArrayCounter = 0;
    patchresponsed = true
    let patchArray = []
    let loadedGroup = this.props.thisgroup;
    let loadedGroupRegFee = this.props.groupregistrationfee;
    if (typeof loadedGroupRegFee === 'undefined') {
      loadedGroupRegFee = {'amount':0,'payed':0}
    }
    if (typeof this.props.groupregistrationfee !== "undefined") {
      loadedGroupRegFee = this.props.groupregistrationfee;
      loadedGroupRegFee.amount = parseInt(String(loadedGroupRegFee.amount).replace(/[' ']/g,''))
      loadedGroupRegFee.payed = parseInt(String(loadedGroupRegFee.payed).replace(/[' ']/g,''))
    } else {
      loadedGroupRegFee = {"amount":0,"payed":0}
    }

    let commentss = [];
    if (typeof comments !== "undefined") {
      comments.forEach(function(item, index){
        if(item.text !== null) {
          let itemtime = loadedGroup.comments[index].time
          commentss.push({"text" : item.text,"time" : itemtime});
        }
      })
    }
    if (typeof commentsnew !== "undefined") {
      commentss.push({"text" : commentsnew.text})
    }

    let dateString1;
    if (typeof startDate !== 'undefined' && startDate !== null) {
      if(startDate.length === 10) {
        dateString1 = startDate;
      } else {
        if(typeof startDate === 'string'){startDate = new Date(startDate)}
        startDate.setMinutes(startDate.getMinutes() - startDate.getTimezoneOffset());
        // dateString1 = startDate.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
        dateString1 = startDate.toISOString().slice(0,10)
      }
    }

    let dateString2;
    if (typeof endDate !== 'undefined' && endDate !== null) {
      if(endDate.length === 10) {
        dateString2 = endDate;
      } else {
        if(typeof endDate === 'string'){endDate = new Date(endDate)}
        endDate.setMinutes(endDate.getMinutes() - endDate.getTimezoneOffset());
        //dateString2 = endDate.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
        dateString2 = endDate.toISOString().slice(0,10)
      }
    }

    if (typeof loadedGroup.leaders[0] !== 'undefined') {
      if (typeof loadedGroup.leaders[0].name !== 'undefined') {
        delete loadedGroup.leaders[0].name;
      }
      if (typeof loadedGroup.leaders[0].email !== 'undefined') {
        delete loadedGroup.leaders[0].email;
      }
      if (typeof loadedGroup.leaders[0].birthday !== 'undefined') {
        delete loadedGroup.leaders[0].birthday;
      }
      if (typeof loadedGroup.leaders[0].tbNumber !== 'undefined') {
        delete loadedGroup.leaders[0].tbNumber;
      }
      if (typeof loadedGroup.leaders[0].indexNumber !== 'undefined') {
        delete loadedGroup.leaders[0].indexNumber;
      }
    }

    if (typeof loadedGroup.leaders[1] !== 'undefined') {
      if (typeof loadedGroup.leaders[1].name !== 'undefined') {
        delete loadedGroup.leaders[1].name;
      }
      if (typeof loadedGroup.leaders[1].email !== 'undefined') {
        delete loadedGroup.leaders[1].email;
      }
      if (typeof loadedGroup.leaders[1].birthday !== 'undefined') {
        delete loadedGroup.leaders[1].birthday;
      }
      if (typeof loadedGroup.leaders[1].tbNumber !== 'undefined') {
        delete loadedGroup.leaders[1].tbNumber;
      }
      if (typeof loadedGroup.leaders[1].indexNumber !== 'undefined') {
        delete loadedGroup.leaders[1].indexNumber;
      }
    }
    let leaderss = [];
    if (typeof leaders !== "undefined") {
      leaders.forEach(function(item, index){
        /*
        if(item !== null) {
          leaderss.push({"id" : item.id,"name" : item.name,"email" : item.email,"birthday" : item.birthday,"tbNumber" : item.tbNumber,"indexNumber" : item.indexNumber});
        }
        */
        if(item.name !== null) {
          leaderss.push(
            {
              "id" : item.id,
              //"name" : item.name,
              //"email" : item.email !== "" ? item.email !== null ? item.email : void(0) : void(0),
              //"birthday" : item.birthday !== "" ? item.birthday !== null ? item.birthday : void(0) : void(0),
              //"tbNumber" : item.tbNumber !== "" ? item.tbNumber !== null ? item.tbNumber : void(0) : void(0),
              //"indexNumber" : item.indexNumber !== "" ? item.indexNumber !== null ? item.indexNumber : void(0) : void(0)
            }
          );
        }
      })
    }

    if (typeof loadedGroup.groupSupervisor !== 'undefined') {
      if (typeof loadedGroup.groupSupervisor.name !== 'undefined') {
        delete loadedGroup.groupSupervisor.name;
      }
      if (typeof loadedGroup.groupSupervisor.email !== 'undefined') {
        delete loadedGroup.groupSupervisor.email;
      }
      if (typeof loadedGroup.groupSupervisor.birthday !== 'undefined') {
        delete loadedGroup.groupSupervisor.birthday;
      }
      if (typeof loadedGroup.groupSupervisor.tbNumber !== 'undefined') {
        delete loadedGroup.groupSupervisor.tbNumber;
      }
      if (typeof loadedGroup.groupSupervisor.indexNumber !== 'undefined') {
        delete loadedGroup.groupSupervisor.indexNumber;
      }
    }

    let groupSupervisorz;
    if (typeof groupSupervisor !== "undefined" && groupSupervisor.name !== null) {
      if(groupSupervisor !== null) {
        groupSupervisorz = {
          "id" : groupSupervisor.id,
          //"name" : groupSupervisor.name,
          //"email" : groupSupervisor.email !== "" ? groupSupervisor.email !== null ? groupSupervisor.email : void(0) : void(0),
          //"birthday" : groupSupervisor.birthday !== "" ? groupSupervisor.birthday !== null ? groupSupervisor.birthday : void(0) : void(0),
          //"indexNumber" : groupSupervisor.indexNumber !== "" ? groupSupervisor.indexNumber !== null ? groupSupervisor.indexNumber : void(0) : void(0),
          //"tbNumber" : groupSupervisor.tbNumber !== "" ? groupSupervisor.tbNumber !== null ? groupSupervisor.tbNumber : void(0) : void(0)
        };
      }
    }
    
    let lessonCountz;
    if (typeof lessonCount !== 'undefined') {
      lessonCountz = parseInt(lessonCount, 10)
    }
    
    let participantCountz;
    if (typeof participantCount !== 'undefined') {
      participantCountz = parseInt(participantCount, 10)
    }
    
    let registrationFeez;
    if (typeof registrationFee !== 'undefined') {
      registrationFeez = parseInt(registrationFee, 10)
    }

    let edited = {
      "id" : id, 
      "positionNumber" : positionNumber,
      "type" : type,
      "leaders" : leaderss,
      "groupSupervisor" : groupSupervisorz,
      "startDate" : dateString1,
      "endDate" : dateString2,
      "lessonCount" : lessonCountz,
      "location" : location,
      "participantCount" : participantCountz,
      "registrationFee" : registrationFeez,
      "recordDelivered" : recordDelivered === '' ? false : recordDelivered,
      "comments" : commentss,
      "participants" : loadedGroup.participants,
      "groupRegistrationFee" : loadedGroup.groupRegistrationFee,
    }

    delete loadedGroup.isSaved;
    var patch = jsonpatch.compare(loadedGroup, edited)
    patchArray.push({
      endpoint: '/groups',
      params: '/'+id,
      patchvar: patch,
      needalert: false
    })
    loadedGroup.isSaved = true;

    let groupRegistrationFeez;
    if (typeof groupRegistrationFee !== "undefined") {
      let dateString3;
      if (typeof groupRegistrationFee.paymentDate !== 'undefined' && groupRegistrationFee.paymentDate !== null) {
        if(groupRegistrationFee.paymentDate.length === 10) {
          dateString3 = groupRegistrationFee.paymentDate;
        } else {
          if(typeof groupRegistrationFee.paymentDate === 'string'){groupRegistrationFee.paymentDate = new Date(groupRegistrationFee.paymentDate)}
          groupRegistrationFee.paymentDate.setMinutes(groupRegistrationFee.paymentDate.getMinutes() - groupRegistrationFee.paymentDate.getTimezoneOffset());
          //dateString3 = groupRegistrationFee.paymentDate.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
          dateString3 = groupRegistrationFee.paymentDate.toISOString().slice(0,10)
        }
      }
      let payed;
      if (typeof groupRegistrationFee.payed !== 'undefined' && groupRegistrationFee.payed !== null && groupRegistrationFee.payed !== '') {
        payed = parseInt(String(groupRegistrationFee.payed).replace(/[' ']/g,''))
      } else {
        payed = 0;
      }
      let amount;
      if (typeof groupRegistrationFee.amount !== 'undefined' && groupRegistrationFee.amount !== null && groupRegistrationFee.amount !== '') {
        amount = parseInt(String(groupRegistrationFee.amount).replace(/[' ']/g,''))
      } else {
        amount = 0;
      }
      groupRegistrationFeez = {
        "amount" : amount,
        "payed" : payed,
        "paymentDate": dateString3,
        "invoiceNumber": groupRegistrationFee.invoiceNumber
      };
      if (typeof this.props.groupregistrationfee !== "undefined") {
        groupRegistrationFeez.type = this.props.groupregistrationfee.type;
        groupRegistrationFeez.editPath = this.props.groupregistrationfee.editPath;
        groupRegistrationFeez.reason = this.props.groupregistrationfee.reason;
      }
    } else {
      groupRegistrationFeez = {'amount':0,'payed':0}
      if (typeof this.props.groupregistrationfee !== "undefined") {
        groupRegistrationFeez.type = this.props.groupregistrationfee.type;
        groupRegistrationFeez.editPath = this.props.groupregistrationfee.editPath;
        groupRegistrationFeez.reason = this.props.groupregistrationfee.reason;
      }
    }
    let edited2 = groupRegistrationFeez
    var patch2 = jsonpatch.compare(loadedGroupRegFee, edited2)
    patchArray.push({
      endpoint: '/groups',
      params: '/'+id+'/group-registration-fee',
      patchvar: patch2,
      needalert: false
    })

    loadedGroup.participants.map((option, index) => {
      let participantChecker = option;  // participants from initial
      let haveThis = participants.filter(participant => (participantChecker.id === participant.id))
      if (haveThis.length < 1 || haveThis[0].name === false ) {
        patchArray.push({
          del: true,
          endpoint: '/groups',
          params: '/'+id+'/participants/'+participantChecker.id,
          patchvar: [],
          needalert: false
        })
      }
    })

    if (typeof participants !== 'undefined') {
      participants.map((option, index) => {
        let savedParticipant = option;
        let loadedParticipant = {}
        let maybeAParticipant = loadedGroup.participants.filter(participant => (participant.id === savedParticipant.id))
        if (maybeAParticipant.length > 0) {
          loadedParticipant = maybeAParticipant[0]
        }
        // registrationFee
          let editedParticipantFee = savedParticipant.registrationFee;
          if(typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.paymentDate !== 'undefined' && editedParticipantFee.paymentDate.length !== 10 && editedParticipantFee.paymentDate !== null) {
              if(typeof editedParticipantFee.paymentDate === 'string'){editedParticipantFee.paymentDate = new Date(editedParticipantFee.paymentDate)}
              editedParticipantFee.paymentDate.setMinutes(editedParticipantFee.paymentDate.getMinutes() - editedParticipantFee.paymentDate.getTimezoneOffset());
              //editedParticipantFee.paymentDate = editedParticipantFee.paymentDate.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
              editedParticipantFee.paymentDate = editedParticipantFee.paymentDate.toISOString().slice(0,10)
          }
          if(typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.notice1 !== 'undefined' && editedParticipantFee.notice1.length !== 10 && editedParticipantFee.notice1 !== null) {
              if(typeof editedParticipantFee.notice1 === 'string'){editedParticipantFee.notice1 = new Date(editedParticipantFee.notice1)}
              editedParticipantFee.notice1.setMinutes(editedParticipantFee.notice1.getMinutes() - editedParticipantFee.notice1.getTimezoneOffset());
              //editedParticipantFee.notice1 = editedParticipantFee.notice1.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
              editedParticipantFee.notice1 = editedParticipantFee.notice1.toISOString().slice(0,10)
          }
          if(typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.notice2 !== 'undefined' && editedParticipantFee.notice2.length !== 10 && editedParticipantFee.notice2 !== null) {
              if(typeof editedParticipantFee.notice2 === 'string'){editedParticipantFee.notice2 = new Date(editedParticipantFee.notice2)}
              editedParticipantFee.notice2.setMinutes(editedParticipantFee.notice2.getMinutes() - editedParticipantFee.notice2.getTimezoneOffset());
              editedParticipantFee.notice2 = editedParticipantFee.notice2.toISOString().slice(0,10)
          }
          if (typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.amount !== 'undefined') {
            if (typeof editedParticipantFee.amount === 'string') {
                editedParticipantFee.amount = parseInt(editedParticipantFee.amount.replace(/[' ']/g,''))
            }
          }
          if (typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.payed !== 'undefined') {
            if (typeof editedParticipantFee.payed === 'string') {
              editedParticipantFee.payed = parseInt(editedParticipantFee.payed.replace(/[' ']/g,''))
            }
          }
          if (typeof editedParticipantFee !== 'undefined' && typeof editedParticipantFee.isRemissed !== 'undefined' && editedParticipantFee.isRemissed === '') {
            editedParticipantFee.isRemissed = false
          }
        // save
        let participantPatch = jsonpatch.compare(loadedParticipant, savedParticipant)
        if (participantPatch.length > 0) {
          patchArray.push({
            endpoint: '/groups',
            params: '/'+id+'/participants/'+savedParticipant.id,
            patchvar: jsonpatch.compare(loadedParticipant, savedParticipant),
            needalert: false
          })
        }
      })
    }

    let propsforpatch = this.props;
    let that = this;
    let cntrObj = {}
    cntrObj.lngt = patchArray.length;
    function patcher(maybeSave) {
      console.log(patchArray)
      console.log(maybeSave)
      //console.log(patchArray)
      if (maybeSave === true) {

        if (patchresponsed === true) {
          console.log('? patchArray.length === patchArrayCounter '+patchArray.length+'-'+patchArrayCounter)
          if (patchArray.length === patchArrayCounter) {
            console.log('patchArray.length === patchArrayCounter')
            // All PATCH done
            propsforpatch.fetchMessage('/groups/self-knowledge', params); // refresh list
            hasEdited = false;
            propsforpatch.openGroup('/groups', '/'+id); // refresh single
            propsforpatch.openGroupregistrationfee('/groups', '/'+propsforpatch.thisgroup.id+'/group-registration-fee', '');
            alert('Sikeres módosítás')
            patcher = null
          } else {
            document.getElementsByTagName("body")[0].addEventListener('patchresponse'+patchArrayCounter, function (e) {
              // we have response
              patchresponsed = true
              patchArrayCounter++
              if (patcher !== null) {
                patcher(shouldSave);
              }
            }, false)
            if (typeof patchArray[patchArrayCounter] !== 'undefined' && typeof patchArray[patchArrayCounter].del !== 'undefined' && patchArray[patchArrayCounter].del === true) {
              propsforpatch.deleteParticipant(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArrayCounter)
            } else {
              propsforpatch.patchItem(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArray[patchArrayCounter].patchvar, patchArray[patchArrayCounter].needalert, patchArrayCounter)
            }
            patchresponsed = false
          }
        }

      } else {
        if (that.state.iscloserequest) {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            that.setState({isemptyonclose : true})
            return true
          } else {
            that.setState({isemptyonclose : false})
            return false
          }
        } else {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            propsforpatch.closeGroup()
            propsforpatch.fetchMessage('/groups/self-knowledge', params);
            that.setState({open: false});
            that.setState({openedform: false});
          } else {
            if (window.confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            propsforpatch.closeGroup()
            propsforpatch.fetchMessage('/groups/self-knowledge', params);
            that.setState({open: false});
            that.setState({openedform: false});
            }
          }
        }

      }
    }
    patcher(shouldSave);
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({query, start, year}) {
    params = '?';
    if (typeof query !== 'undefined') {
      params = params + '&q='+query
    }
    if (typeof year !== 'undefined' && year !== 'all') {
      params = params + '&year='+year
    }
    //if (typeof start !== 'undefined' && start !== null) {
    //  start.setMinutes(start.getMinutes() - start.getTimezoneOffset());
    //  // params = params + '&start='+start.toLocaleDateString('hu-HU').replace(/[\.]/g, '-').replace(/[' ']/g, '').replace(/\-$/, '')
    //  params = params + '&start='+start.toISOString().slice(0,10)
    //}
    window.scrollTo(document.body, 0, 1250);
    this.setState({filterparams: params});
    this.props.fetchMessage('/groups/self-knowledge', params);
  }

  handleFakeSubmit = (should) => {
    if (should === false) {
      shouldSave = false;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    } else {
      shouldSave = true;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    }
  }
  
  csvExport = () => {
    let d = new Date();
    let t = d.getTime();
    let fullparam = '?'
    if (typeof this.state.filterparams !== 'undefined' && this.state.filterparams !== '') {
      if (this.state.filterparams.indexOf('?') > -1) {
        fullparam = this.state.filterparams+'&t='+t
      } else {
        fullparam = '?'+this.state.filterparams+'&t='+t
      }
    } else {
      fullparam = fullparam+'t='+t
    }
    var request = new XMLHttpRequest();
    request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/groups/self-knowledge.csv'+fullparam);
    request.responseType = 'blob';
    request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
    var blob;
    request.onload = function() {
      blob = request.response;
      FileSaver.saveAs(blob, "self-knowledge.csv");
    };
    request.send();
  }

  render() {
    if(typeof this.props.message !== 'undefined') {
      let uu = uuidv4();
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="Önismereti csoportok"
          />
          <Dialog
            actions={[
              <RaisedButton label='Mentés' onTouchTap={ this.handleFakeSubmit } primary={true} />,
              <FlatButton label='Bezár' onTouchTap={ this.handleClose } />
            ]}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={styles.customContentStyle}
          >
            <SkgroupForm
              handleClose={this.handleClose.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              errorMessage={this.props.errorMessage}
              groupinfos={this.props.thisgroup}
              autocomplete={this.props.autocomplete}
              autocomplete2={this.props.autocomplete2}
              tracker={this.props.tracker}
              fetchMessage={this.props.fetchMessage}
              patchItem={this.props.patchItem}
              openGroup={this.props.openGroup}
              grouptypes={this.props.grouptypes}
              //trainingstatus={this.props.trainingstatus}
              groupregistrationfee={this.props.groupregistrationfee}
              openGroupregistrationfee={this.props.openGroupregistrationfee}
            />
          </Dialog>
          <SkgroupsListFilter
            onSubmit={this.handleFilter.bind(this)}
            //groupsbyyear={this.props.groupsbyyear}
            tracker={this.props.tracker2}
            errorMessage={this.props.errorMessage} />
          <div>
            <FlatButton label="CSV Export" onClick={this.csvExport.bind(this)} />
          </div>
          <List>
          {
            this.props.message.map((option, index) => {
              let type;
              if (typeof option.type !== "undefined") {
                if (option.type.length > 0) {
                  type = <span>
                    <span style={{color: darkBlack}}>Típus:</span>
                    <span> {option.type} </span>
                  </span>
                }
              }
              let positionNumber;
              if (typeof option.positionNumber !== "undefined") {
                if (option.positionNumber.length > 0) {
                  positionNumber = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Pozíció szám:</span>
                    <span> {option.positionNumber} </span>
                  </span>
                }
              }
              let leaders;
              if (typeof option.leaders !== "undefined") {
                if (option.leaders > 0) {
                  leaders = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Vezető:</span>
                    {
                      option.leaders.map((option, index) => {
                        return <span> {option} </span>
                      })
                    }
                  </span>
                }
              }
              let date;
              if (typeof option.startDate !== "undefined") {
                if (option.startDate.length > 0) {
                  date = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Kurzus ideje:</span>
                    <span> {option.startDate} - {option.endDate} </span>
                  </span>
                }
              }
              let lessonCount;
              if (typeof option.lessonCount !== "undefined") {
                if (option.lessonCount.length > 0) {
                  lessonCount = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Cím:</span>
                    <span> {option.lessonCount} </span>
                  </span>
                }
              }
              return <ListItem
                onClick={this.handleOpen.bind(this, option.id)}
                key={index}
                leftIcon={<SocialGroup />}
                primaryText={
                  <span>
                    <span style={{color: darkBlack}}>{positionNumber} - </span>
                    <small style={{color: lightBlack}}>
                      {type}
                      {leaders}
                      {date}
                      {lessonCount}
                    </small>
                  </span>
                }
                />
            })

          }
          </List>
          <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
              if (this.props.message.length > 49) {
                this.props.fetchMoreMessage('/groups/self-knowledge', params+'&offset='+this.props.message.length+'&limit=50');
              }
            }}
          />
          <FloatingActionButton className="plusGroup" style={styles.plusButton} onClick={this.handleNewOpen.bind(this, uu)} key={uu}>
            <ContentAdd />
          </FloatingActionButton>

        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>

      )

    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    thisgroup: state.groups.thisgroup,
    autocomplete: state.groups.autocomplete,
    autocomplete2: state.groups.autocomplete2,
    tracker: state.form.skgroup,
    tracker2: state.form.skgroupsListFilter,
    grouptypes: state.groups.grouptypes,
    groupregistrationfee: state.groups.groupregistrationfee,
    // trainingstatus: state.groups.trainingstatus,
    // groupsbyyear: state.statistics.groupsbyyear,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Skgroups)


// WEBPACK FOOTER //
// ./src/components/selfknowledgegroups/selfknowledgegroups.js